var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{class:_vm.styleInput,attrs:{"type":"text"},domProps:{"value":_vm.value},on:{"keydown":_vm.checkNumberKey,"input":_vm.checkNumberInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }